(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["humm-stereo-bundle"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '[data-humm-bundle-selector]';
  const ACTIVE_ATTR = 'data-humm-native-pair-active';
  const CART_ADD_RE = /\/cart\/add(?:\.js)?(?:\?|$)/;
  const MOBILE_LAYOUT_QUERY = '(max-width: 767px)';

  const getProductScope = (root) =>
    root.closest('xo-product') || root.closest('.main-product') || document;

  const getForm = (root) => {
    const product = getProductScope(root);
    const forms = Array.from(product.querySelectorAll('form[action*="/cart/add"]'));

    return (
      forms.find((form) => form.querySelector('xo-cart-add')) ||
      forms.find((form) => form.querySelector('.xo-product-info-content__add')) ||
      forms[0] ||
      null
    );
  };

  const setError = (root, message) => {
    const error = root.querySelector('[data-humm-bundle-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  };

  const getPrimaryInput = (root) =>
    root.querySelector(
      'xo-product-variants input[xo-variant-id]:checked, xo-product-variants input[data-variant-id]:checked'
    );

  const getPrimaryVariantId = (root) => {
    const input = getPrimaryInput(root);
    if (input) return input.getAttribute('xo-variant-id') || input.dataset.variantId || '';

    const form = getForm(root);
    return form?.querySelector('[name="id"]')?.value || '';
  };

  const getSecondaryInput = (root) =>
    root.querySelector('[data-humm-secondary-color]:checked');

  const getSecondaryVariantId = (root) =>
    getSecondaryInput(root)?.dataset.variantId || '';

  const getVariantMap = (root) => {
    if (root._hummVariantMap) return root._hummVariantMap;

    try {
      root._hummVariantMap = JSON.parse(
        root.querySelector('[data-humm-variant-map]')?.textContent || '[]'
      );
    } catch {
      root._hummVariantMap = [];
    }

    return root._hummVariantMap;
  };

  const getVariantEntry = (root, variantId) =>
    getVariantMap(root).find((entry) => String(entry.id) === String(variantId));

  const updateImage = (root, selectorName, variantId) => {
    if (!variantId) return;

    const item = getVariantEntry(root, variantId);

    if (!item?.image) return;

    root.querySelectorAll(selectorName).forEach((image) => {
      image.src = item.image;
      image.removeAttribute('srcset');
    });
  };

  /*
   * 1 Speaker price, compare-at price and discount pill.
   * Editor text overrides always win. Otherwise the values follow the
   * currently selected variant's compare-at price.
   */
  const updateSinglePlanPricing = (root) => {
    const item = getVariantEntry(root, getPrimaryVariantId(root));
    if (!item) return;

    if (item.price) {
      root.querySelectorAll('[data-humm-single-price]').forEach((element) => {
        element.textContent = item.price;
      });
    }

    const compareOverride = root.dataset.singleCompareOverride || '';
    const compareValue = compareOverride || item.compare || '';

    root.querySelectorAll('[data-humm-single-compare]').forEach((element) => {
      element.textContent = compareValue;
      element.hidden = !compareValue;
    });

    const badgeOverride = root.dataset.singleBadgeOverride || '';
    const badgeValue = badgeOverride || item.badge || '';

    root.querySelectorAll('[data-humm-single-badge]').forEach((element) => {
      element.textContent = badgeValue;
      element.hidden = !badgeValue;

      const plan = element.closest('.humm-stereo-bundle__plan--single');
      if (plan) {
        plan.classList.toggle('humm-stereo-bundle__plan--has-badge', Boolean(badgeValue));
      }
    });
  };

  const syncResponsiveLayout = (root) => {
    /* GLO: the richer desktop builder (photo swatches, savings summary) now
       renders at every width — the separate flat-circle mobile builder this
       used to switch to below 767px is never shown. */
    const isMobile = false;
    void MOBILE_LAYOUT_QUERY;

    root.querySelectorAll('.humm-stereo-bundle__desktop-builder').forEach((builder) => {
      builder.hidden = isMobile;
    });

    const mobileBuilder = root.querySelector('[data-humm-mobile-builder]');
    const pricingHost = root.querySelector('[data-humm-mobile-pricing-host]');

    if (pricingHost) {
      pricingHost.hidden = !isMobile;
    }

    if (!mobileBuilder) return;

    /*
     * Remember the original Liquid position once. On desktop the mobile
     * selector is restored here and hidden, so desktop markup/layout stays
     * exactly as it was. On mobile the same selector is moved directly below
     * whichever plan is selected, creating the accordion/dropdown behavior.
     */
    if (!root._hummMobileBuilderHomeParent) {
      root._hummMobileBuilderHomeParent = mobileBuilder.parentNode;
      root._hummMobileBuilderHomeNext = mobileBuilder.nextSibling;
    }

    root.querySelectorAll('.humm-stereo-bundle__plan-option').forEach((option) => {
      option.classList.remove('humm-stereo-bundle__plan-option--expanded');
    });

    if (!isMobile) {
      const homeParent = root._hummMobileBuilderHomeParent;
      const homeNext = root._hummMobileBuilderHomeNext;

      if (homeParent) {
        if (homeNext && homeNext.parentNode === homeParent) {
          homeParent.insertBefore(mobileBuilder, homeNext);
        } else {
          homeParent.appendChild(mobileBuilder);
        }
      }

      mobileBuilder.hidden = true;
      return;
    }

    const checkedPlan = root.querySelector('[data-humm-bundle-mode]:checked');
    const activeOption = checkedPlan?.closest('.humm-stereo-bundle__plan-option');

    if (activeOption) {
      activeOption.appendChild(mobileBuilder);
      activeOption.classList.add('humm-stereo-bundle__plan-option--expanded');
      mobileBuilder.hidden = false;
    }
  };

  const getPrimaryDisplayPrice = (root) => {
    const variantId = getPrimaryVariantId(root);
    const item = getVariantEntry(root, variantId);

    if (item?.price) return item.price;

    return (
      root.querySelector('[data-humm-single-price]')?.textContent?.trim() ||
      root.querySelector('.humm-stereo-bundle__plan-price')?.textContent?.trim() ||
      ''
    );
  };

  const updateMobilePricing = (root) => {
    const isPair = root.dataset.mode === 'pair';
    const singlePrice = getPrimaryDisplayPrice(root);

    const finalPrice = isPair ? root.dataset.pairPrice : singlePrice;
    const subtotal = isPair ? root.dataset.pairComparePrice : singlePrice;
    const savings = isPair ? root.dataset.pairSavings : '$0.00';

    root.querySelectorAll('[data-humm-mobile-price-value]').forEach((element) => {
      element.textContent = finalPrice;
    });

    root.querySelectorAll('[data-humm-mobile-subtotal-value]').forEach((element) => {
      element.textContent = subtotal;
    });

    root.querySelectorAll('[data-humm-mobile-savings-value]').forEach((element) => {
      element.textContent = savings;
    });

    root.querySelectorAll('[data-humm-mobile-savings-label]').forEach((element) => {
      element.textContent = root.dataset.mobileSavingsLabel || 'You save';
    });

    root.querySelectorAll('[data-humm-mobile-compact-label]').forEach((element) => {
      element.textContent = root.dataset.mobilePriceLabel || 'Your price';
    });

    root.querySelectorAll('[data-humm-mobile-compact-savings]').forEach((element) => {
      element.hidden = !isPair;
      element.textContent = isPair ? `save ${savings}` : '';
    });
  };

  const updateMobilePresentation = (root) => {
    const primary = getPrimaryInput(root);
    const secondary = getSecondaryInput(root);
    const primaryValue = primary?.value || '';
    const secondaryValue = secondary?.value || '';

    root.querySelectorAll('[data-humm-mobile-primary-value]').forEach((button) => {
      const selected = button.dataset.hummMobilePrimaryValue === primaryValue;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    root.querySelectorAll('[data-humm-mobile-secondary-value]').forEach((button) => {
      const selected = button.dataset.hummMobileSecondaryValue === secondaryValue;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    root.querySelectorAll('[data-humm-mobile-primary-name]').forEach((element) => {
      element.textContent = primaryValue;
    });

    root.querySelectorAll('[data-humm-mobile-secondary-name]').forEach((element) => {
      element.textContent = secondaryValue;
    });

    /* Gallery does not change on variant select, so the bundle's own
       image swap is switched off. Commented, not deleted. */
//     updateImage(
//       root,
//       '[data-humm-mobile-primary-image]',
//       getPrimaryVariantId(root)
//     );

    /* Gallery does not change on variant select, so the bundle's own
       image swap is switched off. Commented, not deleted. */
//     updateImage(
//       root,
//       '[data-humm-mobile-secondary-image]',
//       getSecondaryVariantId(root)
//     );

    updateMobilePricing(root);
  };

  const activatePrimaryColor = (root, value) => {
    const input = Array.from(
      root.querySelectorAll(
        'xo-product-variants input[xo-variant-id], xo-product-variants input[data-variant-id]'
      )
    ).find((item) => item.value === value && !item.disabled);

    if (!input) return;

    input.click();
  };

  const activateSecondaryColor = (root, value) => {
    const input = Array.from(
      root.querySelectorAll('[data-humm-secondary-color]')
    ).find((item) => item.value === value && !item.disabled);

    if (!input) return;

    input.click();
  };

  const updateSummary = (root) => {
    const primary = getPrimaryInput(root);
    const secondary = getSecondaryInput(root);
    const target = root.querySelector('[data-humm-summary-colors]');

    if (target) {
      target.textContent = [primary?.value, secondary?.value]
        .filter(Boolean)
        .join(' + ');
    }

    /* Gallery does not change on variant select, so the bundle's own
       image swap is switched off. Commented, not deleted. */
//     updateImage(
//       root,
//       '[data-humm-primary-image],[data-humm-plan-primary-image]',
//       getPrimaryVariantId(root)
//     );

    /* Gallery does not change on variant select, so the bundle's own
       image swap is switched off. Commented, not deleted. */
//     updateImage(
//       root,
//       '[data-humm-secondary-image],[data-humm-plan-secondary-image]',
//       getSecondaryVariantId(root)
//     );

    updateSinglePlanPricing(root);
    updateMobilePresentation(root);
  };

  const syncSecondToPrimary = (root) => {
    if (root.dataset.secondaryTouched === 'true') return;

    const primary = getPrimaryInput(root);
    if (!primary) return;

    const secondary = Array.from(
      root.querySelectorAll('[data-humm-secondary-color]')
    ).find((input) => input.value === primary.value && !input.disabled);

    if (secondary) secondary.checked = true;
  };

  const lockQuantity = (root) => {
    const form = getForm(root);
    const quantity = form?.querySelector('[name="quantity"]');

    if (quantity && quantity.value !== '1') {
      quantity.value = '1';
      quantity.setAttribute('value', '1');
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  const syncMode = (root) => {
    const pair =
      root.querySelector('[data-humm-bundle-mode="pair"]')?.checked === true;

    root.dataset.mode = pair ? 'pair' : 'single';

    root.querySelectorAll('[data-humm-pair-only]').forEach((element) => {
      element.hidden = !pair;
    });

    root.querySelectorAll('[data-humm-mobile-pair-only]').forEach((element) => {
      element.hidden = !pair;
    });

    root.querySelectorAll('.humm-stereo-bundle__mobile-secondary').forEach((element) => {
      element.hidden = !pair;
    });

    const secondary = root.querySelector('[data-humm-secondary-wrap]');
    if (secondary) secondary.hidden = !pair;

    const primaryLabel = root.querySelector(
      'xo-product-variants .xo-product-variant__inner-name span:first-child'
    );

    if (primaryLabel) {
      primaryLabel.textContent = pair
        ? root.dataset.primaryPairLabel
        : root.dataset.singleColorLabel;
    }

    root.querySelectorAll('[data-humm-mobile-primary-title]').forEach((element) => {
      element.textContent = pair
        ? root.dataset.primaryPairTitle
        : root.dataset.singleColorLabel;
    });

    if (pair) syncSecondToPrimary(root);

    /* Move the mobile selector directly under the newly selected plan. */
    syncResponsiveLayout(root);

    lockQuantity(root);
    updateSummary(root);
    setError(root, '');
  };

  const isPairValid = (root) =>
    Boolean(getPrimaryVariantId(root) && getSecondaryVariantId(root));

  const getPairItems = (root) => {
    const firstId = getPrimaryVariantId(root);
    const secondId = getSecondaryVariantId(root);

    if (!firstId || !secondId) return null;

    if (String(firstId) === String(secondId)) {
      return [{ id: String(firstId), quantity: 2 }];
    }

    return [
      { id: String(firstId), quantity: 1 },
      { id: String(secondId), quantity: 1 }
    ];
  };

  const clearCartFields = (body) => {
    body.delete('id');
    body.delete('quantity');

    Array.from(body.keys()).forEach((key) => {
      if (/^items\[\d+\]\[(id|quantity)\]$/.test(key)) {
        body.delete(key);
      }
    });
  };

  const appendPairItems = (body, items) => {
    items.forEach((item, index) => {
      body.append(`items[${index}][id]`, String(item.id));
      body.append(`items[${index}][quantity]`, String(item.quantity));
    });
  };

  const rewriteBody = (body, items) => {
    if (!body || !items?.length) return body;

    if (body instanceof FormData) {
      clearCartFields(body);
      appendPairItems(body, items);
      return body;
    }

    if (body instanceof URLSearchParams) {
      clearCartFields(body);
      appendPairItems(body, items);
      return body;
    }

    if (typeof body === 'string') {
      const params = new URLSearchParams(body);
      clearCartFields(params);
      appendPairItems(params, items);
      return params.toString();
    }

    return body;
  };

  const getRequestUrl = (input) => {
    if (typeof input === 'string') return input;
    if (input instanceof URL) return input.href;
    if (typeof Request !== 'undefined' && input instanceof Request) return input.url;
    return '';
  };

  const getActivePairRoot = () =>
    document.querySelector(`${selector}[${ACTIVE_ATTR}="true"]`);

  /*
   * XO's add response can represent a mixed-color pair as one "add action",
   * which can leave <xo-cart-size> showing 1 even though Shopify's cart
   * item_count is 2. This only corrects the header badge after a Stereo Pair
   * add. It does not control the drawer, cart rendering, or add-to-cart flow.
   */
  const refreshHeaderCartCount = (fetchImpl) => {
    if (typeof fetchImpl !== 'function') return;

    const root =
      window.Shopify?.routes?.root ||
      document.documentElement.getAttribute('data-shopify-root') ||
      '/';

    const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
    const cartJsonUrl = `${normalizedRoot}cart.js`;

    fetchImpl(cartJsonUrl, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to refresh cart count.');
        return response.json();
      })
      .then((cart) => {
        const itemCount = Number(cart?.item_count);

        if (!Number.isFinite(itemCount)) return;

        document.querySelectorAll('xo-cart-size').forEach((counter) => {
          counter.textContent = String(itemCount);
        });
      })
      .catch(() => {
        // Badge refresh is non-critical; XO/Shopify still own the cart flow.
      });
  };

  const consumePairPayload = () => {
    const root = getActivePairRoot();
    if (!root || !root._hummNativePairItems) return null;

    const payload = {
      root,
      items: root._hummNativePairItems
    };

    root.removeAttribute(ACTIVE_ATTR);
    root._hummNativePairItems = null;

    if (root._hummPairCleanupTimer) {
      clearTimeout(root._hummPairCleanupTimer);
      root._hummPairCleanupTimer = null;
    }

    return payload;
  };

  /*
   * Native XO cart integration + Shopify automatic discount
   * --------------------------------------------------------
   * XO still owns the normal Add to Bag click, loading state, Shopify request,
   * cart count refresh, cart drawer rendering and cart drawer opening.
   *
   * When Stereo Pair is selected, this snippet changes only the FINAL outgoing
   * /cart/add payload so Shopify receives exactly two qualifying GLO units:
   *
   *   Green + White -> Green x1 + White x1
   *   Green + Green -> Green x2
   *
   * The Buy 1, Get 2nd 30% off discount is NOT applied by JavaScript.
   * Shopify applies the active automatic Buy X Get Y discount server-side
   * when the cart contains qualifying HUMM GLO units.
   *
   * There is no discount-code request, no custom cart refresh, no manual drawer
   * opening and no redirect in this snippet.
   */
  const installNativeCartBridge = () => {
    if (window.__hummStereoNativeCartBridgeInstalled) return;
    window.__hummStereoNativeCartBridgeInstalled = true;

    if (typeof window.fetch === 'function') {
      const nativeFetch = window.fetch.bind(window);

      window.fetch = function(input, init) {
        const url = getRequestUrl(input);

        if (!CART_ADD_RE.test(url)) {
          return nativeFetch(input, init);
        }

        const payload = getActivePairRoot();
        if (!payload?._hummNativePairItems) {
          return nativeFetch(input, init);
        }

        const items = payload._hummNativePairItems;

        // Most XO cart calls use fetch(url, { body: FormData }).
        if (init?.body) {
          const nextInit = { ...init, body: rewriteBody(init.body, items) };
          consumePairPayload();

          const request = nativeFetch(input, nextInit);

          // Do not delay XO. Refresh only the header quantity badge after
          // Shopify has accepted the pair request.
          request.then((response) => {
            if (response.ok) refreshHeaderCartCount(nativeFetch);
          });

          return request;
        }

        // Defensive support if XO passes a Request instance instead.
        if (typeof Request !== 'undefined' && input instanceof Request) {
          consumePairPayload();

          return input.clone().formData().then((formData) => {
            const rewritten = rewriteBody(formData, items);
            const nextRequest = new Request(input, {
              body: rewritten,
              method: input.method,
              headers: input.headers,
              credentials: input.credentials,
              mode: input.mode,
              cache: input.cache,
              redirect: input.redirect,
              referrer: input.referrer,
              referrerPolicy: input.referrerPolicy,
              integrity: input.integrity,
              keepalive: input.keepalive,
              signal: input.signal
            });

            const request = nativeFetch(nextRequest);

            request.then((response) => {
              if (response.ok) refreshHeaderCartCount(nativeFetch);
            });

            return request;
          });
        }

        consumePairPayload();
        return nativeFetch(input, init);
      };
    }

    if (typeof XMLHttpRequest !== 'undefined') {
      const nativeOpen = XMLHttpRequest.prototype.open;
      const nativeSend = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function(method, url) {
        this.__hummRequestUrl = String(url || '');
        return nativeOpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function(body) {
        if (!CART_ADD_RE.test(this.__hummRequestUrl || '')) {
          return nativeSend.call(this, body);
        }

        const root = getActivePairRoot();
        if (!root?._hummNativePairItems) {
          return nativeSend.call(this, body);
        }

        const rewritten = rewriteBody(body, root._hummNativePairItems);
        consumePairPayload();

        this.addEventListener(
          'loadend',
          () => {
            if (this.status >= 200 && this.status < 300 && typeof window.fetch === 'function') {
              refreshHeaderCartCount(window.fetch.bind(window));
            }
          },
          { once: true }
        );

        return nativeSend.call(this, rewritten);
      };
    }
  };

  const armNativePairRequest = (root) => {
    const items = getPairItems(root);
    if (!items) return false;

    root._hummNativePairItems = items;
    root.setAttribute(ACTIVE_ATTR, 'true');

    // Cleanup only; this does not control cart timing or drawer behavior.
    if (root._hummPairCleanupTimer) clearTimeout(root._hummPairCleanupTimer);
    root._hummPairCleanupTimer = setTimeout(() => {
      root.removeAttribute(ACTIVE_ATTR);
      root._hummNativePairItems = null;
      root._hummPairCleanupTimer = null;
    }, 5000);

    return true;
  };

  const init = (root) => {
    if (root.dataset.hummInitialized === 'true') return;

    root.dataset.hummInitialized = 'true';
    root.dataset.secondaryTouched = 'false';

    installNativeCartBridge();
    syncResponsiveLayout(root);

    const mobileMedia = window.matchMedia(MOBILE_LAYOUT_QUERY);
    const handleResponsiveChange = () => syncResponsiveLayout(root);

    if (typeof mobileMedia.addEventListener === 'function') {
      mobileMedia.addEventListener('change', handleResponsiveChange);
    } else if (typeof mobileMedia.addListener === 'function') {
      mobileMedia.addListener(handleResponsiveChange);
    }

    root.querySelectorAll('[data-humm-bundle-mode]').forEach((input) => {
      input.addEventListener('change', () => syncMode(root));
    });

    root.querySelectorAll('[data-humm-secondary-color]').forEach((input) => {
      input.addEventListener('change', () => {
        root.dataset.secondaryTouched = 'true';
        updateSummary(root);
        setError(root, '');
      });
    });

    root.querySelectorAll('[data-humm-mobile-primary-value]').forEach((button) => {
      button.addEventListener('click', () => {
        activatePrimaryColor(root, button.dataset.hummMobilePrimaryValue);
      });
    });

    root.querySelectorAll('[data-humm-mobile-secondary-value]').forEach((button) => {
      button.addEventListener('click', () => {
        root.dataset.secondaryTouched = 'true';
        activateSecondaryColor(root, button.dataset.hummMobileSecondaryValue);
      });
    });

    root.querySelector('xo-product-variants')?.addEventListener('change', () => {
      if (root.dataset.mode === 'pair') syncSecondToPrimary(root);
      updateSummary(root);
      setError(root, '');
    });

    const form = getForm(root);

    if (form) {
      form.addEventListener(
        'input',
        (event) => {
          if (event.target.matches('[name="quantity"]')) lockQuantity(root);
        },
        true
      );

      form.addEventListener(
        'change',
        (event) => {
          if (event.target.matches('[name="quantity"]')) lockQuantity(root);
        },
        true
      );

      // Capture before XO's click handler. We only validate and arm the final
      // request rewrite. A valid click continues untouched into <xo-cart-add>.
      const product = getProductScope(root);

      product.addEventListener(
        'click',
        (event) => {
          if (root.dataset.mode !== 'pair') return;

          const submitter = event.target.closest(
            'xo-cart-add button, button[name="add"], button[type="submit"], input[type="submit"]'
          );

          const clickedForm = submitter?.closest('form[action*="/cart/add"]');
          if (!submitter || clickedForm !== form) return;

          if (!isPairValid(root)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            setError(root, 'Select a color for both speakers.');
            return;
          }

          lockQuantity(root);
          setError(root, '');
          armNativePairRequest(root);
          // DO NOT preventDefault / stopPropagation here.
          // XO now performs its normal native cart flow.
        },
        true
      );
    }

    syncMode(root);
  };

  const initAll = (scope) =>
    (scope || document).querySelectorAll(selector).forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), {
      once: true
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
